/*
  CART UPSELL SCRIPT
  - Wires up "+ Add" buttons for one-click adding a recommended product.
  - In the drawer, does a full content refresh after a quick-add so the new
    item, count, and subtotal actually show up — not just the upsell row.
  - On the cart page, reloads after a quick-add so totals/line items update.
  - Watches fetch() calls to /cart/add, /cart/change, /cart/update so the
    upsell row stays in sync with Blum's own cart actions too.
*/
(function () {
  function refreshCartUpsell() {
    var containers = document.querySelectorAll('[data-cart-upsell]');
    if (!containers.length) return;

    fetch(window.location.pathname)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        containers.forEach(function (container) {
          var context = container.getAttribute('data-cart-upsell');
          var selector = context
            ? '[data-cart-upsell="' + context + '"]'
            : '[data-cart-upsell]';
          var newContainer = doc.querySelector(selector);
          if (newContainer && container.parentNode) {
            container.parentNode.replaceChild(newContainer, container);
          }
        });
        bindAddButtons();
      })
      .catch(function (err) {
        console.error('Cart upsell refresh failed:', err);
      });
  }

  function refreshCartDrawerFully() {
    // Our quick-add buttons post straight to /cart/add.js, bypassing Blum's
    // own drawer update flow entirely — so after a successful add from
    // inside the drawer, we replace the whole drawer's inner content (line
    // items, count, subtotal, and the upsell row) with a freshly rendered
    // version, instead of only patching the upsell row. The outer
    // <ecx-cart-drwr id="ecxCartDrawer"> element itself is left untouched,
    // so its open/closed state isn't affected.
    var liveDrawer = document.getElementById('ecxCartDrawer');
    if (!liveDrawer) {
      refreshCartUpsell();
      return;
    }

    fetch(window.location.pathname)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var freshDrawer = doc.getElementById('ecxCartDrawer');
        if (freshDrawer) {
          liveDrawer.innerHTML = freshDrawer.innerHTML;
        }
        bindAddButtons();
      })
      .catch(function (err) {
        console.error('Cart drawer refresh failed:', err);
      });
  }

  function bindAddButtons() {
    document.querySelectorAll('[data-cart-upsell-add]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', function () {
        var wrapper = btn.closest('.cart-upsell__item');
        var select = wrapper ? wrapper.querySelector('.cart-upsell__variant-select') : null;
        var variantId = select ? select.value : btn.getAttribute('data-variant-id');
        if (!variantId) return;

        if (select && select.options[select.selectedIndex] && select.options[select.selectedIndex].disabled) {
          select.focus();
          return;
        }

        var upsellContainer = btn.closest('[data-cart-upsell]');
        var context = upsellContainer ? upsellContainer.getAttribute('data-cart-upsell') : null;

        btn.disabled = true;
        var originalText = btn.textContent;
        btn.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Add to cart failed');
            return res.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:updated'));

            if (context === 'page') {
              window.location.reload();
              return;
            }

            if (context === 'drawer') {
              refreshCartDrawerFully();
              return;
            }

            btn.textContent = 'Added ✓';
            refreshCartUpsell();
            setTimeout(function () {
              btn.disabled = false;
              btn.textContent = originalText;
            }, 1500);
          })
          .catch(function (err) {
            console.error('Add to cart failed:', err);
            btn.disabled = false;
            btn.textContent = originalText;
          });
      });
    });
  }

  var originalFetch = window.fetch;
  window.fetch = function () {
    var result = originalFetch.apply(this, arguments);
    var target = arguments[0];
    var urlStr = typeof target === 'string' ? target : (target && target.url) || '';

    if (
      urlStr.indexOf('/cart/add') !== -1 ||
      urlStr.indexOf('/cart/change') !== -1 ||
      urlStr.indexOf('/cart/update') !== -1
    ) {
      result.then(function () {
        setTimeout(refreshCartUpsell, 300);
      });
    }
    return result;
  };

  document.addEventListener('DOMContentLoaded', bindAddButtons);
  document.addEventListener('cart:updated', refreshCartUpsell);

  window.refreshCartUpsell = refreshCartUpsell;
})();